import {ICrudOptions} from './crud';

//#region INTERFACE IUserAccessApplicationPreferenceSettings
export interface IUserAccessApplicationPreferenceSettings {
  dateFormat: ICrudOptions;
  storeDisplayOrder: ICrudOptions;
}

//#endregion

//#region CONST _DEFAULT_USER_ACCESS_DATE_FORMAT_SETTING
export const _DEFAULT_USER_ACCESS_DATE_FORMAT_SETTING: Readonly<ICrudOptions & Object> = {
  canEdit: true,
  canSubmit: true,
  canView: true,
  isEdited: false,
};
//#endregion

//#region CONST _DEFAULT_USER_ACCESS_STORE_DISPLAY_ORDER_SETTING
export const _DEFAULT_USER_ACCESS_STORE_DISPLAY_ORDER_SETTING: Readonly<ICrudOptions & Object> = {
  canEdit: true,
  canSubmit: true,
  canView: true,
  isEdited: false,
};
//#endregion

//#region CONST _DEFAULT_USER_ACCESS_APPLICATION_PREFERENCE_SETTINGS
export const _DEFAULT_USER_ACCESS_APPLICATION_PREFERENCE_SETTINGS: Readonly<IUserAccessApplicationPreferenceSettings & Object> = {
  dateFormat: _DEFAULT_USER_ACCESS_DATE_FORMAT_SETTING,
  storeDisplayOrder: _DEFAULT_USER_ACCESS_STORE_DISPLAY_ORDER_SETTING,
};
//#endregion
